import { Injectable } from "@angular/core";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { HelpModel } from "common/models/page-models/help/help-data-model";
import { HelpMetaModel } from "common/models/page-models/help/help-form-model";
import { HelpFormDataService } from "common/services/data-services/admin/help/help-form-data.service";
import { TokenService } from "common/services/core-services/get-token.service";

@Injectable({
    providedIn: 'root'
})
export class HelpFormWidgetService extends FormWidgetService<HelpModel> {
    constructor(protected ds: HelpFormDataService,
        private tokenService: TokenService
    ) {
        super(ds);
    }

    override prepareMetaModel(dataModel: any, metaModel: any, routeData: WidgetModel, event: any = null): Promise<HelpMetaModel> {
        return new Promise<any>((resolve, reject) => {

            const tokenDetails = this.tokenService.getDetailsFromToken(
                localStorage.getItem("token")
              );
            //   console.log(tokenDetails?.["tokenData"].role);
              

              if(tokenDetails?.["tokenData"]?.role !== 2)
              {
                // console.log(metaModel.properties.content.propreadOnly);
                metaModel.properties.content.propreadOnly = true;
              }
            resolve(metaModel);

        });
    }

    getMetaModel(): MetaModel {
        const meta = new HelpMetaModel();
        return meta.getMetaModel();
    }
}
